const getExpenseByCenter = (
  allExpenses: any,
  budgets: any,
  center: any,
  year: any
) => {
  var expenses = allExpenses.find((item: any) => item._id === center);

  const { butems } = budgets;
  let janexpenses: number = 0;
  let janlist: any = [];

  let febexpenses: number = 0;
  let feblist: any = [];

  let marexpenses: number = 0;
  let marlist: any = [];

  let aprexpenses: number = 0;
  let aprlist: any = [];

  let mayexpenses: number = 0;
  let maylist: any = [];

  let junexpenses: number = 0;
  let junlist: any = [];

  let julexpenses: number = 0;
  let jullist: any = [];

  let augexpenses: number = 0;
  let auglist: any = [];

  let sepexpenses: number = 0;
  let seplist: any = [];

  let octexpenses: number = 0;
  let octlist: any = [];

  let novexpenses: number = 0;
  let novlist: any = [];

  let decexpenses: number = 0;
  let declist: any = [];

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}01`) {
      janexpenses = janexpenses + expense?.base_value;
      janlist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}02`) {
      febexpenses = febexpenses + expense?.base_value;
      feblist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}03`) {
      marexpenses = marexpenses + expense?.base_value;
      marlist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}04`) {
      aprexpenses = aprexpenses + expense?.base_value;
      aprlist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}05`) {
      mayexpenses = mayexpenses + expense?.base_value;
      maylist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}06`) {
      junexpenses = junexpenses + expense?.base_value;
      junlist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}07`) {
      julexpenses = julexpenses + expense?.base_value;
      jullist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}08`) {
      augexpenses = augexpenses + expense?.base_value;
      auglist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}09`) {
      sepexpenses = sepexpenses + expense?.base_value;
      seplist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}10`) {
      octexpenses = octexpenses + expense?.base_value;
      octlist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}11`) {
      novexpenses = novexpenses + expense?.base_value;
      novlist.push(expense);
    }
  });

  expenses?.list?.forEach((expense: any) => {
    let check = expense?.posting_date.toString().substring(0, 6);
    if (check === `${year}12`) {
      decexpenses = decexpenses + expense?.base_value;
      declist.push(expense);
    }
  });

  const data: any = [
    {
      date: "Jan",
      name: "January",
      expenses: isNaN(janexpenses) ? 0 : Number(janexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[0]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[0]?.capex_amount),
      amt: 2000,
      list: janlist,
    },
    {
      date: "Feb",
      name: "February",
      expenses: isNaN(febexpenses) ? 0 : Number(febexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[1]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[1]?.capex_amount),
      amt: 2000,
      list: feblist,
    },
    {
      date: "Mar",
      name: "March",
      expenses: isNaN(marexpenses) ? 0 : Number(marexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[2]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[2]?.capex_amount),
      amt: 2000,
      list: marlist,
    },
    {
      date: "Apr",
      name: "April",
      expenses: isNaN(aprexpenses) ? 0 : Number(aprexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[3]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[3]?.capex_amount),
      amt: 2000,
      list: aprlist,
    },
    {
      date: "May",
      name: "May",
      expenses: isNaN(mayexpenses) ? 0 : Number(mayexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[4]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[4]?.capex_amount),
      amt: 2000,
      list: maylist,
    },
    {
      date: "Jun",
      name: "June",
      expenses: isNaN(junexpenses) ? 0 : Number(junexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[5]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[5]?.capex_amount),
      amt: 2000,
      list: junlist,
    },
    {
      date: "Jul",
      name: "Jul",
      expenses: isNaN(julexpenses) ? 0 : Number(julexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[6]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[6]?.capex_amount),
      amt: 2000,
      list: jullist,
    },
    {
      date: "Aug",
      name: "August",
      expenses: isNaN(augexpenses) ? 0 : Number(augexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[7]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[7]?.capex_amount),
      amt: 2000,
      list: auglist,
    },
    {
      date: "Sep",
      name: "September",
      expenses: isNaN(sepexpenses) ? 0 : Number(sepexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[8]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[8]?.capex_amount),
      amt: 2000,
      list: seplist,
    },
    {
      date: "Oct",
      name: "October",
      expenses: isNaN(octexpenses) ? 0 : Number(octexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[9]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[9]?.capex_amount),
      amt: 2000,
      list: octlist,
    },
    {
      date: "Nov",
      name: "November",
      expenses: isNaN(novexpenses) ? 0 : Number(novexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[10]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[10]?.capex_amount),
      amt: 2000,
      list: novlist,
    },
    {
      date: "Dec",
      name: "December",
      expenses: isNaN(decexpenses) ? 0 : Number(decexpenses),
      budget: 0,
      opex_budget: butems === undefined ? 0 : Number(butems[11]?.opex_amount),
      capex_budget: butems === undefined ? 0 : Number(butems[11]?.capex_amount),
      amt: 2000,
      list: declist,
    },
  ];

  return data;
};

export default getExpenseByCenter;
